
const abdoSymptomsList=[
{symptom:"distension",
displayAs:"Persistent abdominal distension / bloating",
questionGroup:"duration"
},

{symptom:"upperAbdoMass",
displayAs:"Epigastric Mass",
questionGroup:"mass",
},

{symptom: "hepatosplenomegaly",
displayAs: "Hepatosplenomegaly",
questionGroup:"mass",
},

{symptom: "splenomegaly",
displayAs: "Splenomegaly",
questionGroup:"mass",},

{symptom:"LiverGbMass",
displayAs:"Liver or Gallbladder Mass",
questionGroup:"mass",
},

{symptom:"abdoMass",
displayAs: "Other Abdominal Mass",
questionGroup:"massWithAbdoSite",
},

{symptom:"pelvicMass",
displayAs:"Pelvic Mass",
questionGroup:"massWithSide",
},

{symptom:"ascites",
displayAs:"Ascites",
questionGroup:"ascites"
}

]

export default abdoSymptomsList
